<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="page-title-box">
          <h4 class="page-title">Superior Assessment Schedule</h4>
        </div>
      </div>
    </div>
    <!-- end page title -->
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <!-- advance serach -->
            <div class="d-flex">
              <div class="d-flex flex-column me-2">
                <label class="col-form-label">Program</label>
                <div style="width: 250px">
                  <v-select
                    label="name"
                    v-model="program"
                    :options="programs"
                    :clearable="false"
                    :selectable="
                      (options) => program.short_name != options.short_name
                    "
                    @option:selected="findBatch_programFilter(program)"
                  >
                  </v-select>
                </div>
              </div>
              <div class="d-flex flex-column me-2">
                <label class="col-form-label">Batch</label>
                <div style="width: 180px">
                  <v-select
                    label="batch_no"
                    v-model="batch"
                    :options="batchs"
                    :clearable="false"
                    :selectable="(options) => batch.id != options.id"
                    @option:selected="FilterData(program, batch)"
                  >
                  </v-select>
                </div>
              </div>
              <div class="d-flex mt-4">
                <!-- <div class="col-form-label d-none">hfhd</div> -->
                <div @click="refreshData()" class="icon-css">
                  <i style="color: #4a81d4" class="fe-rotate-cw"></i>
                </div>
              </div>
            </div>
            <!--end advance serach -->
            Hello
{{ hasPermissions(['superior-assessment-schedule-create']) }}
            <div class="d-flex justify-content-end">
              <router-link
                :to="{ name: 'superior-assessment-schedule-create' }"
              >
                <button
                  v-show="!loading"
                  type="button"
                  class="btn btn-sm btn-blue waves-effect waves-light mb-2"
                  v-if="hasPermissions(['superior-assessment-schedule-create'])"
                >
                  <i class="mdi mdi-plus-circle"></i> Add Record
                </button>
              </router-link>
            </div>
            <place-holder v-if="loading"></place-holder>
            <div class="table-responsive" v-if="!loading">
              <table
                class="table table-striped dt-responsive w-100 mb-3"
                id="ojt-assessment-schedule-list-datatable"
                v-if="!loading"
              >
                <thead v-if="!loading">
                  <tr>
                    <th>No.</th>
                    <th>Program Name</th>
                    <th>Batch</th>
                    <th>Level</th>
                    <th
                      v-if="
                        hasPermissions(['superior-assessment-schedule-edit'])
                      "
                    >
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody v-if="!loading">
                  <template
                    v-for="(item, index) in ojtAssessmentSchedule"
                    :key="index"
                  >
                    <tr>
                      <td>{{ ++index }}</td>
                      <td>{{ item.program_name }}</td>
                      <td>{{ item.batch_no }}</td>
                      <td>{{ item.level }}</td>
                      <td
                        v-if="
                          hasPermissions(['superior-assessment-schedule-edit'])
                        "
                      >
                        <span>
                          <router-link
                            class="action-icon"
                            :to="{
                              name: 'superior-assessment-schedule-update',
                              params: {
                                id: item.id,
                              },
                            }"
                          >
                            <i class="mdi mdi-square-edit-outline"></i>
                          </router-link>
                        </span>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//Datatable Program Allocation
import "datatables.net/js/jquery.dataTables.min.js";

import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";
import "datatables.net-bs5/js/dataTables.bootstrap5.min.js";
import "datatables.net-responsive-bs5/css/responsive.bootstrap5.min.css";
import "datatables.net-responsive-bs5/js/responsive.bootstrap5.min.js";
import $ from "jquery";
import axios from "axios";
import { useToast } from "vue-toastification";
import { useStore } from "vuex";
import { computed } from "vue";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
//Mixins
import userHasPermissions from "../../../mixins/userHasPermissions";

export default {
  mixins: [userHasPermissions],
  components: {
    vSelect,
  },
  setup() {
    const toast = useToast();
    const store = useStore();

    // Access user.employee_id using computed property
    const employeeId = computed(() => store.getters["auth/getAuthEmpId"]);

    return { toast, employeeId };
  },
  data() {
    return {
      ojtAssessmentSchedule: [],
      ass: [],
      programs: this.$store.getters["odoo/getAllPrograms"],
      batchs: [],
      program: "",
      batch: "",
      loading: false,
      baseUrl: process.env.VUE_APP_BASE_URL,
      //  
    };
  },
  methods: {
    getIndex(index, innerIndex) {
      let currentIndex = 0;
      for (let i = 0; i < index; i++) {
        currentIndex += this.ojtAssessmentSchedule[i].assessment_detail.length;
      }
      return currentIndex + innerIndex + 1;
    },
    async getOjtAssessmentSchedule() {
      this.loading = true;
      this.$Progress.start();
      await axios
        .get(`${this.baseUrl}admin/v2/superior-assessment-schedule`)
        .then((response) => {
          this.ojtAssessmentSchedule = response.data.data;
          this.loading = false;
          this.$Progress.finish();
        })
        .catch((error) => {
          this.errors = error.response.data.errors;
          this.toast.error("Something Went Wrong!");
        });
      $("#ojt-assessment-schedule-list-datatable").DataTable();
    },
    async getBudgetYear() {
      this.loading = true;
      await axios
        .get(`${this.baseUrl}admin/v1/yearly-training-plans`)
        .then((response) => {
          this.years = response.data.data;
          this.loading = false;
        });
    },
    async findBatch_programFilter(program) {
      this.batch = "";
      this.loading = true;
      await axios
        .get(
          `${this.baseUrl}admin/v1/program-batches/list?program_id=${program.id}`
        )
        .then((response) => {
          this.batchs = response.data.data;
          this.loading = false;
        })
        .catch(() => {
          this.toast.error("Not Found Batch!");
        });

      this.clearFilter();
      $.fn.dataTable.ext.search.push(function (settings, data) {
        const check_program = program?.name == data[1] ? true : false;
        return check_program ? 1 : 0;
      });
      $("#ojt-assessment-schedule-list-datatable").DataTable().draw();
    },
    FilterData(program, batch) {
      this.clearFilter();
      // alert('reach');
      $.fn.dataTable.ext.search.push(function (settings, data) {
        const check_program = program?.name == data[1] ? true : false;
        const check_batch = batch?.batch_no == data[2] ? true : false;

        return check_program && check_batch ? true : false;
      });
      $("#ojt-assessment-schedule-list-datatable").DataTable().draw();
    },
    refreshData() {
      (this.ojtAssessmentSchedule = []), (this.ass = []), (this.month = "");
      this.year = "";
      this.months = [];
      this.years = [];
      this.yearId = "";
      this.batchs = [];
      this.batch = "";
      this.program = "";
      this.clearFilter();
      this.getOjtAssessmentSchedule();
    },

    clearFilter() {
      $.fn.dataTable.ext.search.pop();
      $("#ojt-assessment-schedule-list-datatable").DataTable().draw();
    },
    async getBatch(program_id) {
      this.loading = true;
      await axios
        .get(
          `${this.baseUrl}admin/v1/program-batches/list?program_id=${program_id}`
        )
        .then((response) => {
          this.batch = response.data.data;
          this.loading = false;
        })
        .catch(() => {
          this.toast.error("Not Found Batch!");
        });
    },  
  },

  created() {
    this.clearFilter();
    this.getOjtAssessmentSchedule();
  },
};
</script>

<style>
.page-item.active .page-link {
  z-index: 3;
  color: #fff;
  background-color: #4a81d4;
  border-color: #4a81d4;
}
.status {
  padding: 0.4em;
}
</style>
